import React from 'react';
import type { ChartConfig } from '../../../services/analytics-service';

interface AnalyticsBarChartProps {
  chartConfig: ChartConfig;
  onButtonClick?: (buttonId: string) => Promise<void>;
  activeButtonId: string;
  isLoading?: boolean;
  ChartWrapper: React.ComponentType<{
    chartConfig: ChartConfig;
    chartContent: React.ReactNode;
    onButtonClick?: (buttonId: string) => Promise<void>;
    activeButtonId: string;
    isLoading?: boolean;
  }>;
}

export const AnalyticsBarChart: React.FC<AnalyticsBarChartProps> = ({
  chartConfig,
  onButtonClick,
  activeButtonId,
  isLoading,
  ChartWrapper,
}) => {
  const chartData = chartConfig.data || [];
  const colors = chartConfig.colors || "#72BFE6";
  const maxValue = Math.max(...chartData.map(i => i.value), 1);

  const chartContent = (
    <div className="space-y-5 pt-2">
      {chartData.map((item, index) => {
        const percentage = (item.value / maxValue) * 100;
        const base = colors[index % colors.length];

        return (
          <div key={index} className="flex items-center gap-6 w-full">
            <div className="flex flex-col w-40 text-right">
              <span className="text-base font-semibold text-gray-900">
                {item.name}
              </span>
            </div>

            <div className="relative flex-1 h-10 rounded-r-full overflow-hidden">
              <div
                className="h-10 rounded-r-full transition-all duration-500"
                style={{
                  width: `${percentage}%`,
                  background: `linear-gradient(90deg, ${base}40, ${base})`,
                  borderTopLeftRadius: "0px",
                  borderBottomLeftRadius: "0px",
                }}
              />

              <span className="absolute right-3 top-1/2 -translate-y-1/2 text-sm font-bold text-gray-900">
                {item.value.toLocaleString()}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );

  return (
    <ChartWrapper
      chartConfig={chartConfig}
      chartContent={chartContent}
      onButtonClick={onButtonClick}
      activeButtonId={activeButtonId}
      isLoading={isLoading}
    />
  );
};
